import React from "react";
import { Play } from "lucide-react";

export const YoutubeSection = () => {
  const videos = [
    {
      id: "NHpIRjxddGc",
      title: "Barry John in conversation with Manoj Bajpayee (Part 1/2)",
      thumbnail: "https://img.youtube.com/vi/NHpIRjxddGc/maxresdefault.jpg",
    },
    {
      id: "lfV4AfI3u9g",
      title: "Bollywood stars pays tribute to their acting teacher Barry John!",
      thumbnail: "https://img.youtube.com/vi/lfV4AfI3u9g/maxresdefault.jpg",
    },
    {
      id: "p8wqGjzFjdc",
      title:
        "Biography of Barry John | National Award Winner | Over 50years of experience in actor training.",
      thumbnail: "https://img.youtube.com/vi/p8wqGjzFjdc/maxresdefault.jpg",
    },
  ];

  return (
    <section className="py-20 px-6 lg:px-8 bg-gradient-to-b from-white to-purple-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Experience the Barry John Method
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Watch the master himself explain the art and craft of acting
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {videos.map((video, index) => (
            <a
              key={index}
              href={`https://www.youtube.com/watch?v=${video.id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Thumbnail */}
              <div className="relative aspect-video bg-gray-900">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors duration-300">
                  <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center group-hover:scale-110 group-hover:bg-purple-500 transition-all duration-300 shadow-xl">
                    <Play
                      className="w-7 h-7 text-white ml-1"
                      fill="currentColor"
                    />
                  </div>
                </div>
              </div>

              {/* Title */}
              <div className="p-5">
                <h4 className="font-medium text-gray-900 group-hover:text-purple-600 transition-colors duration-300 line-clamp-2">
                  {video.title}
                </h4>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
